import { cn } from "@/lib/utils";
import { Loader2 } from "lucide-react";

interface AnimatedLoaderProps {
    className?: string;
    size?: "sm" | "md" | "lg";
    text?: string;
    height?: number;
    width?: number;
    strokeColor?: string;
    strokeWidth?: number
}

const CircularDotsLoader = ({ className, text, size = "sm", height = 150, width = 150, strokeColor = "#10B981", strokeWidth = 1 }: AnimatedLoaderProps) => {
    const sizeClasses = {
        sm: "w-32 h-32",
        md: "w-64 h-64",
        lg: "w-96 h-96",
    };

    return (
        <div
            className={cn(
                "relative flex items-center justify-center z-[1000] pointer-events-auto",
                sizeClasses[size],
                className
            )}
        >
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                <div className="flex flex-col items-center justify-center space-y-4 p-6">
                    <Loader2 className="animate-spin" style={{ width: width, height: height, color: strokeColor }} strokeWidth={strokeWidth} />
                    {text && <div className="text-white text-xl">
                        {text}
                    </div>
                    }
                </div>
            </div>
        </div>
    );
};

export default CircularDotsLoader;
